import { z } from "zod";
import { timestampSchema } from "../common/primitives.js";
/**
 * Kiracının KVKK ayarları (ADR 0017 §10): TTS / plaka tanıma okumalarının saklama süresi (varsayılan 30 gün,
 * "doğrulanmalı" — #64) ve pazarlama iletisinde görünen gönderici adı. Kayıt yoksa varsayılanlar `isDefault: true`,
 * `version: 0` ile döner; ilk `PUT` satırı açar.
 */
export const DEFAULT_VEHICLE_READ_RETENTION_DAYS = 30;
export const privacySettingsSchema = z.object({
    vehicleReadRetentionDays: z.number().int(),
    marketingSenderName: z.string().nullable(),
    isDefault: z.boolean(),
    updatedAt: timestampSchema.nullable(),
    version: z.number().int(),
});
export const savePrivacySettingsSchema = z.object({
    vehicleReadRetentionDays: z.number().int().min(1).max(3650),
    marketingSenderName: z.string().trim().min(2).max(40).nullable().default(null),
    version: z.number().int().min(0).describe("İlk kayıtta 0"),
});
//# sourceMappingURL=settings.js.map